export const isDevlopment = () => {
  if (import.meta.env.VITE_APP_IS_DEVELOPMENT === "true") {
    return true;
  }
  return false;
};
